exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".AdminOnly-05ff79fe:after{content:'admin';vertical-align:top;font-size:8px;display:inline-block}\n", ""]);

// Exports
exports.locals = {
	"AdminOnly": "AdminOnly-05ff79fe"
};